import { useQuery } from '@tanstack/react-query'
import type { ActiveCallsResponse } from '@sbclite/core/sip/active-calls'
import { api } from '../services/api'

const QUERY_KEY = ['active-calls'] as const

export function useActiveCalls(enabled: boolean) {
  return useQuery<ActiveCallsResponse>({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const response = await api.get<ActiveCallsResponse>('/api/active-calls')
      return response.data
    },
    enabled,
    refetchInterval: enabled ? 5000 : false,
    refetchOnWindowFocus: true,
  })
}
